import React from 'react';

// Small presentational helper — sums pricing totals across requested courts.
// Kept in its own file because the shell and the review step both consume it.
export default function TotalDisplay({ courtsPricing }) {
  const courtsTotal = (courtsPricing || []).reduce(
    (sum, pricing) => sum + (pricing?.total || 0),
    0,
  );
  return (
    <p className="text-3xl font-black font-heading" data-testid="total-price">
      BND {courtsTotal.toFixed(2)}
    </p>
  );
}
